<template>
  <div class="">
    <div v-if="!hideNavigation" class="header">
      <div class="navigation">
        <div class="btnList">
          <div class="btn" @click.stop="$refs.calendar.prev()">
            &lt;
          </div>
          <div class="btn" @click.stop="centerToday()">
            Aujourd'hui
          </div>
          <div class="btn" @click.stop="$refs.calendar.next()">
            &gt;
          </div>
        </div>
      </div>
    </div>
    <div class="agenda">
      <v-calendar
        ref="calendar"
        v-model="focus"
        :weekdays="[1, 2, 3, 4, 5, 6, 0]"
        type="week"
        :events="events"
        :event-color="getEventColor"
        @change="getEvents"
        @click:event="showEvent"
        :first-interval="6"
        :interval-count="17"
        :interval-height="60"
      >
        <template #event="{ event }">
          <div
            class="v-event-draggable pa-1"
          >
            <div><strong>Bays #{{event.bays}}</strong><br>{{displayHour(event)}}</div>
            <div>{{event.name}}</div><br>
          </div>
        </template>
        </v-calendar>
    </div>
    <reservation-form v-model="reservation" :type="type" :event="event" @updateAgenda="getEvents"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import fr from 'moment/locale/fr'
import ReservationForm from "./ReservationForm"
moment.updateLocale('fr', fr)
export default {
  components: { ReservationForm },
  props: {
    hideNavigation: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    focus:'',
    startDate: null,
    event:null,
    type:null,
    reservation:false
  }),
  computed: {
    ...mapGetters("schedulerReservation", ["events"]),
  },
  mounted () {
  },
  methods: {
    ...mapActions("schedulerReservation",{getReservations:"list"}),
    getEvents(e){
      if(e){
        this.startDate = e.start.date;
      }else if(!this.startDate){
        this.startDate= moment().format("YYYY-MM-DD");
      }
      this.getReservations(this.startDate)
    },
    centerToday () {
      this.focus = ''
    },
    showEvent({ nativeEvent, event }) {
      nativeEvent.preventDefault();
      nativeEvent.stopPropagation();
      this.event = Object.assign({},event);
      this.reservation=true;
    },
    editReservation(e){
      console.log("Edit : " ,e)
    },
    createReservation(e){
      console.log("Create : ", e)
    },
    
    getEventColor (event) {
      return event.color
    },
    displayHour(event){
      return moment(event.start).format("HH:mm") + " - " + moment(event.end).format("HH:mm")
    }
  }
}
</script>

<style lang="less" scoped>
.agenda{
  .labels{
    display: grid;
    grid-template-columns: repeat(7,minmax(0,1fr));
    text-align: center;
    margin-bottom: 10px;
  }
  .days{
    display: grid;
    grid-template-columns: repeat(7,minmax(0,1fr));
    > div{
      position: relative;
    }
  }
}
.header{
  margin-bottom: 20px;
  .navigation{
    display:flex;
    flex-direction:column;
    align-items: flex-end;
    .btnList{
      display: flex;
      box-shadow: 0 3px 6px rgba(0,0,0,.16);
      margin-top: 1rem;
      .btn{
        background-color: white;
        padding: 0 1rem;
        border-right: 1px solid #efefef;
        cursor: pointer;
        &:hover{
          background-color: #fafafa;
        }
      }
    }
  }
}
</style>
